var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPositive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 10,
    viewBox: "0 0 13 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1194 9.36457H2.69937C2.36696 9.36505 2.04121 9.27139 1.75982 9.09441C1.47843 8.91744 1.25291 8.6644 1.10937 8.36457C0.941338 8.00883 0.876619 7.61304 0.922588 7.2223C0.968557 6.83157 1.12337 6.4616 1.36937 6.15457L5.57937 1.05457C5.74459 0.863943 5.94885 0.711057 6.17832 0.606276C6.40779 0.501494 6.65711 0.447266 6.90937 0.447266C7.16163 0.447266 7.41095 0.501494 7.64042 0.606276C7.86989 0.711057 8.07415 0.863943 8.23937 1.05457L12.4494 6.15457C12.6954 6.4616 12.8502 6.83157 12.8962 7.2223C12.9421 7.61304 12.8774 8.00883 12.7094 8.36457C12.5658 8.6644 12.3403 8.91744 12.0589 9.09441C11.7775 9.27139 11.4518 9.36505 11.1194 9.36457Z",
    fill: "#32D583"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPositive);
export default __webpack_public_path__ + "static/media/positive.8e50c063db790eed9a88d40bf58ddadf.svg";
export { ForwardRef as ReactComponent };